import { Icon } from '@iconify/react';
import React, { useRef, useState } from 'react';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined'
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';


// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText, Box } from '@mui/material';
import { useAuth } from '../../customContextProviders/AuthContext';
import { APP_CONSTANTS } from '../../../URLConstants';

// ----------------------------------------------------------------------

export default function OrganizationUsersMoreMenu({ handleUser, handleClicks, sx }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { sessionUserData } = useAuth()


  const isUserRoleNotSuperAdmin = handleUser?.role !== APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN;
  const isNotSameRole = sessionUserData?.user?.role !== handleUser?.role;
  const isSuperAdmin = sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN;
  const isAdmin = sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_ADMIN;

  const result = (isUserRoleNotSuperAdmin && isNotSameRole) && (isSuperAdmin || isAdmin);



  return (
    <Box data-testid='user-menu'>
      <IconButton data-testid='user-more-menu' sx={{ ...sx }} ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}

        PaperProps={{
          sx: { minWidth: 200, maxWidth: '100%' }

        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >


        {
          handleUser?.deletedAt !== undefined && handleUser?.deletedAt !== null && handleUser?.deletedAt !== "" ?

            <MenuItem onClick={() => { setIsOpen(false); handleClicks("reactivate_user") }} sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <VerifiedUserOutlinedIcon color="success" />
              </ListItemIcon>
              <ListItemText primary="Re-activate User" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>
            :

            <MenuItem onClick={() => { setIsOpen(false); handleClicks("deactivate_user") }} sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <RemoveCircleOutlineOutlinedIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="De-activate User" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>

        }



        {
          result
            ?
            <MenuItem onClick={() => { setIsOpen(false); handleClicks("update_user") }} sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <VerifiedUserOutlinedIcon color="success" />
              </ListItemIcon>
              <ListItemText primary="Update User" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>
            :
            null

        }



      </Menu>
    </Box>
  );
}
